module.exports = __webpack_public_path__ + "img/product9.1351101c.jpg";